import { createSlice } from "@reduxjs/toolkit";
import { comment } from "../../api/endpoints";
const initialState = {
  token: null,
  loader:true,
  modal:false,
  login:false,
  advertisement_data :[],
  filterdata: [],
  bannerData:[],
  categoryid: {},
  rangevalue:{
    max:0,
    min:100
  },
  blogcomment :{},
  reply:{},
  brandname:"",
  bannerId:"",
  forgetpass:{
    email:false,
    otp:false,
    confirmpassword:false
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setFilter: (state, action) => {
      state.filterdata = action.payload;
    },
    setBanner: (state, action) => {
      state.bannerData = action.payload;
    },
    setCategoryid: (state, action) => {
      state.categoryid = action.payload;
    },
    setRangeslider: (state, action) => {
      state.rangevalue = action.payload;  
    },
    setBlogcomment: (state, action) => {
      state.blogcomment = action.payload;
    },
    setReply: (state, action) => {
      state.reply = action.payload;
    },
    setBrand: (state, action) => {
      state.brandname = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setModal: (state, action) => {
      state.modal = action.payload;
    },
    setLogin: (state, action) => {
      state.login = action.payload;
    },
    setAdvertisement: (state, action) => {
      state.advertisement_data = action.payload;
    },
    setBanner_id : (state,action) =>{
      state.bannerId = action.payload;
    },
    setForgetPassword : (state,action) =>{
      state.forgetpass = action.payload;
    }
  },
});

export const {
  setToken: setTokenAction,
  setFilter,
  setCategoryid,
  setRangeslider,
  setBlogcomment,
  setReply,
  setBrand,
  setLoader,
  setModal,
  setLogin,
  setBanner,
  setAdvertisement,
  setBanner_id,
  setForgetPassword
} = authSlice.actions;
export default authSlice;
